import { CreateLogger, warn } from "@swivl-mono/helpers";
import { AppType, EscalationInterface, Log } from "@swivl-mono/types";
import { Call, Device } from "@twilio/voice-sdk";
import { nanoid } from "nanoid";
import { BiVolume } from "react-icons/bi";

import { UsersModel } from "../../Users/Users.Model";
import CallModel, { CallStatus } from "../Call.Model";
import { Member } from "../../Member/Member.Current";
import { API } from "@swivl-mono/api-helper";

const log = CreateLogger(Log.VOICE, "CallModel.Helpers");

export function GetPhoneNumberForForEscalation(escalation: EscalationInterface, formated: boolean): string {
  if (!escalation) {
    return "";
  }
  if (escalation.user?.phoneNumber) {
    return formated ? CallModelFormatPhoneNumber(escalation.user.phoneNumber) : escalation.user.phoneNumber;
  }
  let users = UsersModel.state.users;
  if (escalation.userId && users && users[escalation.userId] && users[escalation.userId].phoneNumber) {
    return formated ? CallModelFormatPhoneNumber(users[escalation.userId].phoneNumber || "") : users[escalation.userId].phoneNumber || "";
  }
  return "";
}

export function CallModelFormatPhoneNumber(phoneNumber: string) {
  return phoneNumber.replace(/\D/g, "").startsWith("1") ? `+${phoneNumber.replace(/\D/g, "")}` : `+1${phoneNumber.replace(/\D/g, "")}`;
}

// function CallModelDecodeJwt(token: string): DecodedJwt | undefined {
//   const tokenParts = token.split(".");
//   if (tokenParts.length === 3) {
//     const payload = JSON.parse(atob(tokenParts[1]));
//     payload.exp = new Date(payload.exp * 1000);
//     payload.iat = new Date(payload.iat * 1000);
//     return payload as DecodedJwt;
//   }
//   throw new Error("Invalid token");
// }

function GetLatestStateForCall(call: Call) {
  if (!CallModel.activeCall || CallModel.activeCall !== call) {
    warn("trying to set status on none active call...this is probably not an issue but just in case");
    // return;
  }
  const status = call.status();
  console.log("GetLatestStateForCall :", status);

  CallModel.setState({ callStatus: status as unknown as CallStatus });
}

export async function CallModelRegisterCallEvents(call: Call) {
  const callSid = call.parameters.CallSid;
  log("[CallModel Call] callSid :", callSid);

  // CallModel.setState({ callStates: states });

  log("[CallModel Call] Registering call events", call);

  call.on("accept", (call) => {
    GetLatestStateForCall(call);
    log("[CallModel Call] Accepting call", call);

    console.log("The incoming call was accepted or the outgoing calls media session has finished setting up.");
  });
  // call.on("connect", (...arg1) => {
  //   log("[CallModel Call] Accepting call", arg1);
  //   GetLatestStateForCall(callSid);
  // });

  call.on("disconnect", (...arg1) => {
    log("[CallModel Call] Disconnecting call", arg1);
    CallModel.handleCallCleanup();

    GetLatestStateForCall(call);
  });

  call.on("error", (error) => {
    log("[CallModel Call] Error on call", error);
    CallModel.handleCallCleanup();
    GetLatestStateForCall(call);
  });

  call.on("cancel", (...arg1) => {
    log("[CallModel Call] cancel event");
    CallModel.handleCallCleanup();
    GetLatestStateForCall(call);
  });
  call.on("messageReceived", (...arg1) => {
    log("[CallModel Call] messageReceived event", arg1);
    GetLatestStateForCall(call);
  });
  call.on("messageSent", (...arg1) => {
    log("[CallModel Call] messageSent event", arg1);
    GetLatestStateForCall(call);
  });
  call.on("mute", () => {
    log("[CallModel Call] mute event");
    GetLatestStateForCall(call);
  });
  call.on("reconnected", () => {
    log("[CallModel Call] reconnected event");
    GetLatestStateForCall(call);
  });
  call.on("reconnecting", () => {
    log("[CallModel Call] reconnecting event");
    GetLatestStateForCall(call);
  });
  call.on("reject", () => {
    log("[CallModel Call] reject event");
    GetLatestStateForCall(call);
  });
  call.on("ringing", (...arg1) => {
    log("[CallModel Call] ringing event", arg1);
    GetLatestStateForCall(call);
  });
  // call.on("audio", () => {
  //   log("[CallModel Call] audio event");
  // });
  // call.on("sample", () => {
  //   log("[CallModel Call] sample event");
  // });
  // call.on("volume", () => {
  //   log("[CallModel Call] volume event");
  // });
  call.on("warningCleared", () => {
    log("[CallModel Call] warningCleared event");
    GetLatestStateForCall(call);
  });
  call.on("warning", () => {
    log("[CallModel Call] warning event");
    GetLatestStateForCall(call);
  });
}

export function CallModelDeviceInit(twilioToken: string) {
  CallModel.device = new Device(twilioToken);

  if (!CallModel.device) {
    return null;
  }

  CallModel.device.audio?.on("deviceChange", (lostActiveDevices) => {
    log("[CallModel Device Audio] Audio device change", lostActiveDevices);
  });

  CallModel.device.audio?.on("inputVolume", (volume) => {
    log("[CallModel Device] Input volume", volume);
  });

  CallModel.device.on("incoming", async (call: Call) => {
    log("[CallModel Device] Incoming call", call);

    // const fromNumber = call.parameters.From;
    // CallModel.setCallerNumber(fromNumber);

    // Auto-accept the call.
    // CallModel.acceptCall();
  });

  CallModel.device.on("tokenWillExpire", async (token: string) => {
    log("[CallModel Device] Token will expire", token);
    const twilioApp = await API.Apps.getAppByTypeForLocation(AppType.TWILIO, Member.orgId!);
    if (!twilioApp) {
      warn("No Twilio app found, cannot generate new token");
      return;
    }
    CallModel.generateMemberTwilioToken(twilioApp, { force: true });
  });

  CallModel.device.on("registering", () => {
    log("[CallModel Device] Registering device");
  });

  CallModel.device.on("registered", () => {
    log("[CallModel Device] Device registered");
  });

  CallModel.device.on("unregistered", () => {
    log("[CallModel Device] Device unregistered");
    // CallModel.setStatus(CallStatus.IDLE);
  });

  CallModel.device.on("destroyed", () => {
    log("[CallModel Device] Device destroyed");
    // CallModel.setStatus(CallStatus.IDLE);
  });

  CallModel.device.on("error", (error) => {
    log("[CallModel Device] Error on device", error);
  });
}
